import React, { useContext } from "react";
// import { ContextUser } from "src/context/ContextUser";
import { Text, Tooltip, Badge, Button, Icon } from "@shopify/polaris";
import { useToggleSupplierChatMutation } from "src/graphql/codegen_graphql";
import { ContextUser } from "src/context/ContextUser";
import { InfoMinor } from "@shopify/polaris-icons";

export function EnableChatComponent() {
  const { merchant } = useContext(ContextUser);
  const [toggle] = useToggleSupplierChatMutation({
    refetchQueries: ["merchant"],
  });

  const settingStatusMarkup = (
    <Badge tone={!!merchant.enabledChat ? "success" : undefined} toneAndProgressLabelOverride={`Setting is On`}>
      {!!merchant.enabledChat ? "On" : "Off"}
    </Badge>
  );

  return (
    <div className="mr-2 mt-2" style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
      <div style={{ display: "flex" }}>
        <Text as="h6" variant="headingMd">
          Chat mode
        </Text>
        <div className="ml-2">{settingStatusMarkup}</div>
        <Tooltip
          zIndexOverride={999}
          content={`When the chat mode is off, the button chat will be invisible from your product screen.`}
        >
          <div className="ml-1">
            <Icon source={InfoMinor} tone="subdued" />
          </div>
        </Tooltip>
      </div>

      <div>
        <Button role="switch" size="slim" onClick={() => toggle()}>
          Turn {!!merchant.enabledChat ? "Off" : "On"}
        </Button>
      </div>
    </div>
  );
}
